<template>
	<div v-editable="blok" class="grid grid-cols-1" :class="blok?.offset || ''">
		<h1 v-if="blok.Title" class="!hidden main-wrapper">
			{{ blok.Title }}
		</h1>
		<BlokPriorityScope
			v-for="(body, index) in blok.body"
			:key="body._uid"
			:priority="index <= priorityIndex"
		>
			<StoryblokComponent :blok="body" />
		</BlokPriorityScope>
	</div>
</template>

<script setup lang="ts">
import { lastPriorityIndex } from "~/layers/base/utils/imagePriority";
import type { BlokPage } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokPage;
}
const { blok } = defineProps<Props>();

const priorityIndex = computed(() => lastPriorityIndex(blok.body));
</script>
